import { css as t, keyframes as e } from "styled-components";
const o = {
  sm: t`
    width: 400px;
  `,
  md: t`
    width: 544px;
  `,
  lg: t`
    width: 656px;
  `
}, r = {
  primary: t``,
  side: t`
    height: 100vh;
  `
}, s = {
  open: e`
    from {
      transform: translateX(100%);
    }

    to {
      transform: translateX(0);
    }
  `,
  close: e`
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(100%);
    }
  `
}, a = {
  open: e`
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(0);
    }
  `,
  close: e`
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-100%);
    }
  `
}, i = {
  left: t`
    justify-content: flex-start;
    padding-left: 0px;
  `,
  right: t`
    justify-content: flex-end;
    padding-right: 0px;
  `
}, m = {
  left: t`
    &[data-is-open='true'] {
      animation: ${a.open} 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    &[data-is-open='false'] {
      animation: ${a.close} 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }
  `,
  right: t`
    &[data-is-open='true'] {
      animation: ${s.open} 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    &[data-is-open='false'] {
      animation: ${s.close} 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }
  `
};
export {
  m as sideModalContentAnimations,
  i as sideModalPositionStyles,
  o as sizeStyles,
  r as variantStyles
};
